import { Link } from "react-router-dom";
import BlogSearchBar from "@/pages/blog/components/BlogSearchBar";
import PostCard from "@/pages/blog/components/PostCard";
import {
  contentCategories,
  getFeaturedPosts,
  getRelatedPosts,
  type BlogPost,
} from "@/pages/blog/blogData";

export default function ArticleSidebar({ post }: { post: BlogPost }) {
  const related = getRelatedPosts(post, 4);
  const featured = getFeaturedPosts(4);

  return (
    <aside className="flex flex-col gap-6">
      <div className="rounded-xl border border-background-200 bg-background-50 p-5">
        <p className="text-xs font-semibold uppercase tracking-wider text-foreground-500">
          Pesquisar no blog
        </p>
        <div className="mt-3">
          <BlogSearchBar variant="inline" />
        </div>
      </div>

      <div className="rounded-xl border border-background-200 bg-background-50 p-5">
        <p className="text-xs font-semibold uppercase tracking-wider text-foreground-500">Categorias</p>
        <ul className="mt-3 flex flex-col gap-1">
          {contentCategories.map((category) => (
            <li key={category.slug}>
              <Link
                to={`/blog/${category.slug}`}
                className="flex items-center justify-between gap-2 rounded-md px-2.5 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                <span className="flex items-center gap-2">
                  <i className={`${category.icon} text-base text-foreground-400`} aria-hidden="true"></i>
                  {category.shortName}
                </span>
                <i className="ri-arrow-right-s-line text-base text-foreground-300" aria-hidden="true"></i>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      {related.length > 0 ? (
        <div className="rounded-xl border border-background-200 bg-background-50 p-5">
          <p className="text-xs font-semibold uppercase tracking-wider text-foreground-500">
            Artigos relacionados
          </p>
          <div className="mt-3 flex flex-col gap-3">
            {related.map((item) => (
              <PostCard key={item.slug} post={item} variant="compact" />
            ))}
          </div>
        </div>
      ) : null}

      <div className="rounded-xl border border-background-200 bg-background-50 p-5">
        <p className="text-xs font-semibold uppercase tracking-wider text-foreground-500">
          Conteúdo em destaque
        </p>
        <div className="mt-3 flex flex-col gap-3">
          {featured.map((item) => (
            <PostCard key={item.slug} post={item} variant="compact" />
          ))}
        </div>
      </div>

      <div className="rounded-xl border border-primary-200 bg-primary-50 p-5">
        <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-background-50">
          <i className="ri-customer-service-2-line text-xl" aria-hidden="true"></i>
        </span>
        <p className="mt-3 font-heading text-base font-bold text-foreground-950">
          Precisa de ajuda com o seu projeto?
        </p>
        <p className="mt-2 text-sm leading-relaxed text-foreground-600">
          A NXHOST oferece hospedagem, criação de sites, VPS, SEO e soluções digitais para empresas.
        </p>
        <Link
          to="/solucoes"
          className="mt-4 inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          Conhecer as soluções
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>
    </aside>
  );
}